import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryContainer from '../../components/ErrorBoundaryContainer';
import Loading from '../../components/Loading';

import accountRouter from '../account';

const LogPageComponent = lazy(
  () => import(/* webpackChunkName: "log-page" */ '../../pages/log'),
);

const logRouter = (
  <Route
    path="log/:projectId"
    element={
      <Suspense fallback={<Loading />}>
        <ErrorBoundaryContainer
          key="log-page"
          component={<LogPageComponent />}
        />
      </Suspense>
    }
  >
    {accountRouter()}
  </Route>
);

export default logRouter;
